import { Tag as AntTag, TagProps as AntTagProps } from 'antd'
import styled from 'styled-components'

import { Icon } from '../Icons'

const StyledTag = styled(AntTag)`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: 3px 12px;
  border-radius: 5px;
`

const StyledIcon = styled(Icon)`
  vertical-align: middle;
`

const StyledTagText = styled.span`
  vertical-align: middle;
  padding-right: 8px;
`

export type TagProps = Omit<AntTagProps, 'children'> & {
  text: string
}

export const Tag = ({ text, ...rest }: TagProps) => {
  return (
    <StyledTag {...rest} closeIcon={<StyledIcon type="CloseSquare" />}>
      <StyledTagText>{text}</StyledTagText>
    </StyledTag>
  )
}
